import { GITHUB_APP_CLIENT_ID, GITHUB_APP_REDIRECT_URL } from 'config';

export const handleGithubRedirect = () => {
  const githubClientId = GITHUB_APP_CLIENT_ID;
  const githubRedirectUrl = GITHUB_APP_REDIRECT_URL;
  const ramdomString = (Math.random() + 1).toString(36).substring(7) + 'rdm';

  window.location.href = `https://github.com/login/oauth/authorize?client_id=${githubClientId}&redirect_uri=${githubRedirectUrl}&scope=user:email&state=${ramdomString}`;
};
